import { AlertTriangle, Activity, Bell } from "lucide-react";
import { useAzure } from "@/context/AzureContext";

const SEV = {
  Sev1: "bg-red-500/10 text-red-600 border-red-500/30",
  Sev2: "bg-amber-500/10 text-amber-600 border-amber-500/30",
  Sev3: "bg-blue-500/10 text-blue-600 border-blue-500/30",
};

function Spark({ values, color = "#0078d4" }) {
  if (!values?.length) return null;
  const max = Math.max(...values, 1);
  const w = 160, h = 34, step = w / (values.length - 1);
  const pts = values.map((v, i) => `${i * step},${h - (v / max) * h}`).join(" ");
  return (
    <svg width={w} height={h} className="overflow-visible">
      <polyline fill="none" stroke={color} strokeWidth="1.5" points={pts} />
    </svg>
  );
}

export default function MonitorAlerts() {
  const { state } = useAzure();
  const alerts = state?.alerts || [];
  const mon = state?.monitoring || {};
  return (
    <div data-testid="az-monitor">
      <div className="flex items-center gap-2 border-b border-border pb-3 mb-3">
        <Bell className="h-5 w-5 text-[#0078d4]" /><h2 className="font-semibold">Monitor — alerts &amp; metrics</h2>
      </div>

      <div className="text-sm font-medium mb-2 flex items-center gap-2"><AlertTriangle className="h-4 w-4 text-amber-500" /> Active alerts ({alerts.length})</div>
      <div className="space-y-2" data-testid="az-alerts">
        {alerts.map((a) => (
          <div key={a.id} className={`flex items-center gap-3 border rounded-md px-3 py-2.5 ${SEV[a.severity] || "border-border"}`} data-testid={`az-alert-${a.id}`}>
            <span className="text-xs font-bold px-2 py-0.5 rounded bg-white/50 dark:bg-black/20">{a.severity}</span>
            <div className="min-w-0">
              <div className="text-sm font-medium truncate">{a.name}</div>
              <div className="text-xs opacity-80 truncate">{a.description}</div>
            </div>
            <span className="ml-auto text-xs shrink-0">{a.state} · {a.resource}</span>
          </div>
        ))}
      </div>

      <div className="text-sm font-medium mt-6 mb-2 flex items-center gap-2"><Activity className="h-4 w-4 text-[#0078d4]" /> Percentage CPU (last 24h)</div>
      <div className="grid md:grid-cols-2 gap-4">
        {Object.entries(mon.vm_cpu || {}).map(([name, vals]) => {
          const last = vals[vals.length - 1];
          return (
            <div key={name} className="border border-border rounded-md p-3" data-testid={`az-metric-${name}`}>
              <div className="flex items-center justify-between text-sm">
                <span className="font-medium">{name}</span>
                <span className={`font-mono ${last >= 85 ? "text-red-600" : "text-muted-foreground"}`}>{last}%</span>
              </div>
              <Spark values={vals} color={last >= 85 ? "#dc2626" : "#0078d4"} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
